import { render } from "./DailyReward.vue?vue&type=template&id=0cb0cf52&scoped=true"
import script from "./DailyReward.vue?vue&type=script&lang=js"
export * from "./DailyReward.vue?vue&type=script&lang=js"

import "./DailyReward.vue?vue&type=style&index=0&id=0cb0cf52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb0cf52"]])

export default __exports__